import store from 'lib/services/store'
import { getGeneralInquiry } from 'lib/services/inquiry'
import { mapSelectionsToQuery } from 'lib/utils/filters'

const DEFAULT_SECONDARY_FILTERS = {
  types: [],
  features: [],
  query: [],
}

/**
 * Map individual filters to groups
 * for store.
 */
export const mapFiltersToGroups = (filters) => {
  const groupedFilters = {
    types: [],
    features: [],
  }

  filters.forEach(({ filter, values }) => {
    const group = filter === 'event_type' ? 'types' : 'features'
    groupedFilters[group] = values
  })

  return groupedFilters
}

/**
 * Get active main filters from store.
 */
export const getActiveMainFilters = (filters) => {
  const inquiry = getGeneralInquiry()
  const mainFilterQuery = mapSelectionsToQuery(inquiry, filters)
  return mainFilterQuery
}

const transformSecondaryFiltersToQuery = (storeValue) => {
  const query = []

  if (storeValue.features.length > 0) {
    query.push({
      filter: 'event_feature',
      values: storeValue.features,
    })
  }

  if (storeValue.types.length > 0) {
    query.push({
      filter: 'event_type',
      values: storeValue.types,
    })
  }

  return query
}

/**
 * Get active additional filter groups from store.
 */
export const getActiveAdditionalFilters = () => {
  if (store.isAvailable()) {
    const result = store.getAdditionalFilters()

    if (!result) {
      return DEFAULT_SECONDARY_FILTERS
    }

    result.query = transformSecondaryFiltersToQuery(result)

    return result
  }

  return DEFAULT_SECONDARY_FILTERS
}

/**
 * Save active filters to store. Replaces old ones.
 */
export const saveAdditionalFilters = (filters) => {
  if (store.isAvailable()) {
    const storeFilters = mapFiltersToGroups(filters)
    store.setAdditionalFilters(storeFilters)
  }
}

export default {
  saveAdditionalFilters,
  getActiveAdditionalFilters,
  mapFiltersToGroups,
}
